<template>
    <div class="device_stock_detail" :class="{ has_action_footer: isIotmaxUser && canApplyOut }">
        <div class="detail_header">
            <div class="back_btn" @click="goBack">
                <van-icon name="arrow-left" size="24" />
            </div>
            <span class="header_title">设备信息</span>
            <div class="placeholder"></div>
        </div>

        <div class="loading_wrap" v-if="loading">
            <van-loading size="32px" vertical>加载中...</van-loading>
        </div>

        <template v-else-if="device.device_sn && !isIotmaxUser">
            <div class="minimal_content">
                <div class="minimal_card">
                    <div class="minimal_icon">
                        <van-icon name="qr" size="42" color="#1989fa" />
                    </div>
                    <div class="minimal_title">设备信息</div>
                    <div class="info_row">
                        <span class="label">设备SN</span>
                        <span class="value sn_value">{{device.device_sn || '-'}}</span>
                    </div>
                    <div class="info_row">
                        <span class="label">设备名称</span>
                        <span class="value">{{product.name || '-'}}</span>
                    </div>
                    <div class="info_row">
                        <span class="label">设备型号</span>
                        <span class="value">{{product.code || '-'}}</span>
                    </div>
                    <div class="info_row">
                        <span class="label">生产日期</span>
                        <span class="value">{{formatProductionDate(device.device_time || device.create_time)}}</span>
                    </div>
                    <div class="company_brand" v-if="companyName || companyLogo">
                        <img v-if="companyLogo" :src="companyLogo" :alt="companyName || '公司 Logo'" class="company_logo" @error="handleCompanyLogoError">
                        <div class="company_name">{{companyName}}</div>
                    </div>
                </div>
            </div>
        </template>

        <template v-else-if="device.device_sn && isIotmaxUser">
            <div class="detail_content">
                <div class="status_card" :class="deviceStatus.className">
                    <div>
                        <div class="status_label">设备状态</div>
                        <div class="status_value">{{deviceStatus.text}}</div>
                        <div class="status_warehouse" v-if="isInStock">当前仓库：{{deviceWarehouseName}}</div>
                    </div>
                    <van-icon :name="deviceStatus.icon" size="34" />
                </div>

                <div class="product_card">
                    <div class="product_imgs">
                        <van-swipe v-if="imgList.length" :autoplay="3000" indicator-color="#4E89FF">
                            <van-swipe-item v-for="(img, index) in imgList" :key="index">
                                <img :src="img" @error="handleImgError">
                            </van-swipe-item>
                        </van-swipe>
                        <img v-else src="/static/imgs/no_img.png" @error="handleImgError">
                    </div>
                    <div class="product_main">
                        <div class="product_name">{{product.name || '-'}}</div>
                        <div class="product_code">产品编码：{{product.code || '-'}}</div>
                        <div class="product_intro">{{product.intro || '暂无产品介绍'}}</div>
                    </div>
                </div>

                <div class="info_section">
                    <div class="section_title">设备信息</div>
                    <div class="info_row">
                        <span class="label">设备SN</span>
                        <span class="value sn_value">{{device.device_sn || '-'}}</span>
                    </div>
                    <div class="info_row" v-if="isInStock">
                        <span class="label">当前仓库</span>
                        <span class="value">{{deviceWarehouseName}}</span>
                    </div>
                    <div class="info_row">
                        <span class="label">入库时间</span>
                        <span class="value">{{device.stock_in_time | formatTime}}</span>
                    </div>
                    <div class="info_row">
                        <span class="label">出库时间</span>
                        <span class="value">{{device.stock_out_time | formatTime}}</span>
                    </div>
                    <div class="info_row">
                        <span class="label">设备备注</span>
                        <span class="value">{{device.remark || '-'}}</span>
                    </div>
                </div>

                <div class="info_section">
                    <div class="section_title">检测报告</div>
                    <div class="report_row">
                        <span>出厂报告</span>
                        <van-button v-if="device.factory_report" size="mini" plain type="primary" @click="openReport(device.factory_report)">查看</van-button>
                        <span v-else class="empty_text">未上传</span>
                    </div>
                    <div class="report_row">
                        <span>出货报告</span>
                        <van-button v-if="device.shipment_report" size="mini" plain type="primary" @click="openReport(device.shipment_report)">查看</van-button>
                        <span v-else class="empty_text">未上传</span>
                    </div>
                </div>

                <div class="info_section">
                    <div class="section_title">产品库存</div>
                    <div class="stock_grid">
                        <div class="stock_item">
                            <span class="stock_num">{{product.stock_num || 0}}</span>
                            <span>库存总数</span>
                        </div>
                        <div class="stock_item">
                            <span class="stock_num">{{currentProductStock}}</span>
                            <span>{{deviceWarehouseName}}</span>
                        </div>
                        <div class="stock_item">
                            <span class="stock_num">{{product.assemble_num || 0}}</span>
                            <span>可组装</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="action_footer" v-if="canApplyOut">
                <van-button type="danger" block round icon="logistics" @click="openOutbound">
                    出库
                </van-button>
            </div>
        </template>

        <van-empty v-else description="未找到设备信息">
            <van-button round type="primary" size="small" @click="goBack">返回</van-button>
        </van-empty>

        <van-popup v-if="isIotmaxUser" v-model="showOutbound" position="bottom" round :style="{ height: '72%' }">
            <div class="popup_layout">
                <div class="popup_header">
                    <span>设备出库</span>
                    <van-icon name="cross" @click="showOutbound = false" />
                </div>
                <div class="popup_body">
                    <div class="out_summary">
                        <div>
                            <span class="summary_label">出库产品</span>
                            <strong>{{product.name || '-'}}</strong>
                        </div>
                        <div>
                            <span class="summary_label">出库仓库</span>
                            <strong>{{deviceWarehouseName}}</strong>
                        </div>
                    </div>

                    <div class="selected_header">
                        <span>出库设备（{{selectedDevices.length}}台）</span>
                        <van-button size="mini" plain type="primary" icon="plus" @click="openDeviceSelector">选择更多</van-button>
                    </div>
                    <div class="selected_list">
                        <van-tag v-for="item in selectedDevices" :key="item.id || item.device_sn" plain type="primary" size="medium" class="selected_tag">
                            {{item.device_sn}}
                            <van-icon v-if="!isCurrentDevice(item)" name="cross" @click="removeSelected(item)" />
                        </van-tag>
                    </div>

                    <van-notice-bar v-if="!canSelectDevice(device)" color="#ad6800" background="#fff7e6" left-icon="warning-o">
                        当前设备的出厂报告或出货报告不完整，暂不能提交出库申请
                    </van-notice-bar>

                    <van-field v-model="remark" label="备注" type="textarea" rows="3" maxlength="200" show-word-limit placeholder="选填" />
                </div>
                <div class="popup_footer">
                    <van-button block round type="danger" :loading="submitting" :disabled="!canSubmitOut" @click="submitOutbound">
                        提交出库申请（{{selectedDevices.length}}台）
                    </van-button>
                </div>
            </div>
        </van-popup>

        <van-popup v-if="isIotmaxUser" v-model="showDeviceSelector" position="bottom" round :style="{ height: '88%' }">
            <div class="popup_layout">
                <div class="popup_header">
                    <span>选择同仓未出库设备</span>
                    <van-icon name="cross" @click="showDeviceSelector = false" />
                </div>
                <div class="device_search">
                    <van-search v-model="deviceSearch" placeholder="搜索设备SN" show-action @search="searchDevices" @cancel="resetDeviceSearch" />
                </div>
                <div class="device_list_wrap">
                    <van-pull-refresh v-model="deviceRefreshing" @refresh="refreshDevices">
                        <van-list v-model="deviceListLoading" :finished="deviceListFinished" finished-text="没有更多了" @load="loadDevices">
                            <div v-for="item in deviceList" :key="item.id" class="device_item" :class="{ disabled: !canSelectDevice(item) }" @click="toggleDevice(item)">
                                <div class="device_item_info">
                                    <div class="device_sn">{{item.device_sn || '-'}}</div>
                                    <div class="device_meta">
                                        入库：{{item.stock_in_time | formatTime}}
                                        <span v-if="isCurrentDevice(item)" class="current_label">当前设备</span>
                                    </div>
                                    <div class="report_missing" v-if="!canSelectDevice(item)">出厂报告或出货报告不完整</div>
                                </div>
                                <van-checkbox :value="isSelected(item)" :disabled="isCurrentDevice(item) || !canSelectDevice(item)" @click.stop="toggleDevice(item)" />
                            </div>
                        </van-list>
                    </van-pull-refresh>
                </div>
                <div class="popup_footer">
                    <van-button block round type="primary" @click="showDeviceSelector = false">完成（已选{{selectedDevices.length}}台）</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import studio_api from '@/api/teaching_studio_teaching_studio_api.js'
import no_login_api from '@/api/teaching_studio_no_login.js'
import studio_tool_api from '@/api/teaching_studio_tool.js'
import until from '@/api/until.js'
import {
    formatIotmaxTimestamp,
    getIotmaxFormAuth,
    getStoredIotmaxStock,
    parseIotmaxImageList,
    setStoredIotmaxStock
} from '@/utils/iotmaxStock.js'

export default {
    name: 'DeviceStockDetail',
    data() {
        return {
            loading: true,
            deviceSn: '',
            device: {},
            product: {},
            viewerCanManage: false,
            companyName: '深圳物宇宙技术有限公司',
            companyLogo: '/static/imgs/icon.png',
            imgList: [],
            warehouseList: [],
            currentWarehouse: getStoredIotmaxStock(),
            showOutbound: false,
            showDeviceSelector: false,
            remark: '',
            submitting: false,
            selectedDevices: [],
            deviceList: [],
            deviceSearch: '',
            devicePage: 1,
            devicePageSize: 20,
            deviceListLoading: false,
            deviceListFinished: false,
            deviceRefreshing: false,
            deviceFetching: false
        }
    },
    filters: {
        formatTime(value) {
            return formatIotmaxTimestamp(value)
        }
    },
    computed: {
        deviceStatus() {
            if (!Number(this.device.stock_in_time || 0)) {
                return { text: '待入库', className: 'pending', icon: 'clock-o' }
            }
            if (!Number(this.device.stock_out_time || 0)) {
                return { text: '库存中', className: 'in_stock', icon: 'passed' }
            }
            return { text: '已出库', className: 'out_stock', icon: 'logistics' }
        },
        isIotmaxUser() {
            return this.viewerCanManage
        },
        canApplyOut() {
            return Number(this.device.stock_in_time || 0) > 0 && Number(this.device.stock_out_time || 0) === 0
        },
        isInStock() {
            return Number(this.device.stock_in_time || 0) > 0 && Number(this.device.stock_out_time || 0) === 0
        },
        canSubmitOut() {
            return this.selectedDevices.length > 0 && this.selectedDevices.every(item => this.canSelectDevice(item))
        },
        deviceWarehouseName() {
            const warehouse = this.getDeviceWarehouse()
            return warehouse ? warehouse.stock_name : `仓库${this.device.stock_code || '-'}`
        },
        currentProductStock() {
            const warehouse = this.getDeviceWarehouse()
            return warehouse ? Number(warehouse.StockNum || warehouse.stock_num || 0) : 0
        }
    },
    mounted() {
        document.title = '设备信息'
        this.deviceSn = String(this.$route.query.device_sn || this.$route.query.sn || '').trim()
        this.initPage()
    },
    methods: {
        async initPage() {
            if (!this.deviceSn) {
                this.loading = false
                return
            }
            this.loading = true
            await this.loadDevice()
            if (this.isIotmaxUser) {
                await this.loadWarehouses()
            }
            this.loading = false
        },
        async loadDevice() {
            try {
                const res = await no_login_api.Api_nologinDevice_infoGet({
                    app_id: this.$root.app_id,
                    device_sn: this.deviceSn
                })
                if (res.errcode === 0 && res.other) {
                    const publicInfo = res.other
                    this.viewerCanManage = publicInfo.can_manage === true
                    this.companyName = publicInfo.company_name || '深圳物宇宙技术有限公司'
                    this.companyLogo = publicInfo.company_logo || '/static/imgs/icon.png'
                    if (this.viewerCanManage && publicInfo.device_info) {
                        this.device = publicInfo.device_info
                        this.product = publicInfo.device_info.product_info || {}
                    } else {
                        const deviceTime = publicInfo.device_time || publicInfo.create_time || 0
                        this.device = {
                            device_sn: publicInfo.device_sn,
                            device_time: deviceTime,
                            create_time: deviceTime
                        }
                        this.product = {
                            name: publicInfo.device_name,
                            code: publicInfo.device_model
                        }
                    }
                    this.imgList = parseIotmaxImageList(this.product.imgs)
                } else {
                    this.$toast('未找到设备信息')
                }
            } catch (error) {
                console.error('加载设备信息失败:', error)
                this.$toast('加载设备信息失败')
            }
        },
        async loadWarehouses() {
            try {
                const res = await studio_api.Teaching_studio_apiIotmaxStock_listGet({ app_id: this.$root.app_id })
                if (res.errcode === 0 && Array.isArray(res.other)) {
                    this.warehouseList = res.other
                    const loginWarehouse = res.other.find(item => Number(item.is_login) === 1)
                    if (loginWarehouse) {
                        this.currentWarehouse = loginWarehouse
                        setStoredIotmaxStock(loginWarehouse)
                    }
                }
            } catch (error) {
                console.error('加载仓库列表失败:', error)
            }
        },
        getDeviceWarehouse() {
            const list = Array.isArray(this.product.stock_num_info) ? this.product.stock_num_info : []
            return list.find(item => String(item.stock_code) === String(this.device.stock_code)) ||
                this.warehouseList.find(item => String(item.stock_code) === String(this.device.stock_code)) || null
        },
        formatProductionDate(value) {
            if (!value) return '-'
            if (/^\d+$/.test(String(value))) {
                return formatIotmaxTimestamp(value, { dateOnly: true })
            }
            const date = new Date(String(value).replace(/-/g, '/'))
            if (Number.isNaN(date.getTime())) return String(value)
            const pad = number => String(number).padStart(2, '0')
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
        },
        async openOutbound() {
            if (!this.canApplyOut) return
            if (!this.isCurrentWarehouseMatched()) {
                const switched = await this.confirmWarehouseSwitch()
                if (!switched) return
            }
            this.selectedDevices = [this.device]
            this.remark = ''
            this.showOutbound = true
        },
        isCurrentWarehouseMatched() {
            return this.currentWarehouse && String(this.currentWarehouse.stock_code) === String(this.device.stock_code)
        },
        async confirmWarehouseSwitch() {
            const target = this.getDeviceWarehouse()
            const targetName = target ? target.stock_name : `仓库${this.device.stock_code}`
            const currentName = this.currentWarehouse ? this.currentWarehouse.stock_name : '未选择仓库'
            try {
                await this.$dialog.confirm({
                    title: '切换出库仓库',
                    message: `当前登录仓库为“${currentName}”，设备位于“${targetName}”。是否切换后继续？`
                })
                const res = await studio_api.Teaching_studio_apiIotmaxStock_loginPut({
                    app_id: this.$root.app_id,
                    stock_code: this.device.stock_code
                })
                if (res.errcode !== 0) {
                    this.$toast(res.errmsg || '切换仓库失败')
                    return false
                }
                const warehouse = this.warehouseList.find(item => String(item.stock_code) === String(this.device.stock_code)) || target
                this.currentWarehouse = warehouse || { stock_code: this.device.stock_code, stock_name: targetName }
                setStoredIotmaxStock(this.currentWarehouse)
                return true
            } catch (error) {
                return false
            }
        },
        openDeviceSelector() {
            this.deviceSearch = ''
            this.devicePage = 1
            this.deviceList = []
            this.deviceListFinished = false
            this.showDeviceSelector = true
            this.$nextTick(() => this.loadDevices())
        },
        async loadDevices() {
            if (this.deviceFetching || this.deviceListFinished) {
                this.deviceListLoading = false
                return
            }
            this.deviceFetching = true
            this.deviceListLoading = true
            try {
                const params = {
                    app_id: this.$root.app_id,
                    product_id: this.product.id,
                    need_in_stock: 1,
                    stock_code: this.device.stock_code,
                    device_sn: this.deviceSearch,
                    page: this.devicePage,
                    page_size: this.devicePageSize
                }
                const res = await studio_api.Teaching_studio_apiIotmaxProductDevice_listGet(params)
                if (res.errcode === 0 && res.other) {
                    const other = res.other
                    const list = Array.isArray(other) ? other : (other.list || [])
                    const eligibleList = list.filter(item =>
                        Number(item.stock_in_time || 0) > 0 && Number(item.stock_out_time || 0) === 0
                    )
                    if (this.devicePage === 1) {
                        this.deviceList = eligibleList
                    } else {
                        const existing = new Set(this.deviceList.map(item => item.id))
                        this.deviceList = this.deviceList.concat(eligibleList.filter(item => !existing.has(item.id)))
                    }
                    const total = Number(other.total || other.count || 0)
                    if (!list.length || list.length < this.devicePageSize || (total > 0 && this.deviceList.length >= total)) {
                        this.deviceListFinished = true
                    } else {
                        this.devicePage += 1
                    }
                } else {
                    this.deviceListFinished = true
                }
            } catch (error) {
                console.error('加载同仓设备失败:', error)
                this.$toast('加载设备失败')
                this.deviceListFinished = true
            } finally {
                this.deviceFetching = false
                this.deviceListLoading = false
                this.deviceRefreshing = false
            }
        },
        searchDevices() {
            this.devicePage = 1
            this.deviceList = []
            this.deviceListFinished = false
            this.loadDevices()
        },
        resetDeviceSearch() {
            this.deviceSearch = ''
            this.searchDevices()
        },
        refreshDevices() {
            this.devicePage = 1
            this.deviceList = []
            this.deviceListFinished = false
            this.loadDevices()
        },
        shouldRequireReports() {
            return Number(this.device.stock_code || 0) === 1 && Number(this.product.is_iotmax || 0) === 1
        },
        canSelectDevice(item) {
            if (!this.shouldRequireReports()) return true
            return !!(item && item.factory_report && item.shipment_report)
        },
        isCurrentDevice(item) {
            return item && String(item.device_sn) === String(this.device.device_sn)
        },
        isSelected(item) {
            return this.selectedDevices.some(selected => String(selected.device_sn) === String(item.device_sn))
        },
        toggleDevice(item) {
            if (this.isCurrentDevice(item)) return
            if (!this.canSelectDevice(item)) {
                this.$toast('该设备出厂报告或出货报告不完整，无法选择')
                return
            }
            const index = this.selectedDevices.findIndex(selected => String(selected.device_sn) === String(item.device_sn))
            if (index >= 0) {
                this.selectedDevices.splice(index, 1)
            } else {
                this.selectedDevices.push(item)
            }
        },
        removeSelected(item) {
            if (this.isCurrentDevice(item)) return
            this.selectedDevices = this.selectedDevices.filter(selected => String(selected.device_sn) !== String(item.device_sn))
        },
        async submitOutbound() {
            if (!this.canSubmitOut || this.submitting) return
            try {
                await this.$dialog.confirm({
                    title: '确认出库申请',
                    message: `确定提交${this.selectedDevices.length}台设备的出库申请吗？`
                })
            } catch (error) {
                return
            }

            this.submitting = true
            this.$toast.loading({ message: '提交中...', duration: 0, forbidClick: true })
            try {
                const auth = await getIotmaxFormAuth(studio_tool_api, until)
                const res = await studio_api.Teaching_studio_apiIotmaxStock_out_applyAddPost({
                    app_id: this.$root.app_id,
                    computer_code: auth.computer_code,
                    salt: auth.salt,
                    in_out: 'out',
                    apply_type: 'product',
                    record_id: this.product.id,
                    apply_num: this.selectedDevices.length,
                    studio_id: 0,
                    device_sns: this.selectedDevices.map(item => item.device_sn).join(','),
                    remark: this.remark || '',
                    is_move: 0,
                    old_stock_id: 0,
                    new_stock_id: 0
                })
                this.$toast.clear()
                if (res.errcode === 0) {
                    this.showOutbound = false
                    this.$toast.success('出库申请已提交')
                } else {
                    this.$toast(res.errmsg || '提交出库申请失败')
                }
            } catch (error) {
                this.$toast.clear()
                console.error('提交出库申请失败:', error)
                this.$toast(error.message || '提交出库申请失败')
            } finally {
                this.submitting = false
            }
        },
        openReport(url) {
            if (url) window.open(url, '_blank')
        },
        handleImgError(event) {
            if (event.target.src.includes('no_img.png')) return
            event.target.src = '/static/imgs/no_img.png'
        },
        handleCompanyLogoError(event) {
            const fallbackLogo = '/static/imgs/icon.png'
            if (event.target.src.endsWith(fallbackLogo)) {
                event.target.style.display = 'none'
                return
            }
            event.target.src = fallbackLogo
        },
        goBack() {
            if (!this.isIotmaxUser) {
                const closeWechatWindow = () => {
                    if (window.WeixinJSBridge) {
                        window.WeixinJSBridge.call('closeWindow')
                        return
                    }

                    window.close()
                    if (window.history.length > 1) window.history.back()
                }

                if (!window.WeixinJSBridge && document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', closeWechatWindow, { once: true })
                    window.close()
                } else {
                    closeWechatWindow()
                }
                return
            }

            this.$router.replace('/mine')
        }
    }
}
</script>

<style scoped>
.device_stock_detail { width: 100%; height: 100%; min-height: 0; overflow-y: auto; overflow-x: hidden; -webkit-overflow-scrolling: touch; overscroll-behavior-y: contain; box-sizing: border-box; background: #f6f6f6; padding-bottom: calc(24px + env(safe-area-inset-bottom)); }
.device_stock_detail.has_action_footer { padding-bottom: calc(150px + env(safe-area-inset-bottom)); }
.detail_header { height: 88px; padding: 0 30px; background: #fff; display: flex; align-items: center; justify-content: space-between; box-sizing: border-box; box-shadow: 0 2px 8px rgba(0,0,0,.05); }
.header_title { font-size: 32px; font-weight: 600; color: #222; }
.placeholder, .back_btn { width: 48px; }
.loading_wrap { height: 60vh; display: flex; align-items: center; justify-content: center; }
.minimal_content { padding: 30px 30px 40px; }
.minimal_card { overflow: hidden; padding: 42px 30px 0; background: #fff; border-radius: 24px; box-shadow: 0 8px 28px rgba(31, 41, 55, .08); }
.company_brand { margin: 8px -30px 0; padding: 26px 30px 28px; background: #f8fafc; border-top: 1px solid #edf0f4; display: flex; align-items: center; justify-content: flex-start; gap: 16px; text-align: left; }
.company_logo { display: block; width: 70px; height: 70px; flex: 0 0 70px; object-fit: contain; border-radius: 10px; }
.company_name { color: #4b5563; font-size: 26px; line-height: 1.45; font-weight: 600; letter-spacing: .5px; }
.minimal_icon { width: 78px; height: 78px; margin: 0 auto 14px; border-radius: 50%; background: #eef7ff; display: flex; align-items: center; justify-content: center; box-shadow: inset 0 0 0 1px rgba(25, 137, 250, .06); }
.minimal_title { margin: 0; text-align: center; font-size: 34px; line-height: 1.4; font-weight: 700; color: #111827; }
.minimal_subtitle { margin: 8px 0 28px; text-align: center; font-size: 23px; line-height: 1.4; color: #9ca3af; }
.minimal_card .info_row { min-height: 98px; padding: 22px 8px; font-size: 28px; }
.minimal_card .info_row .label { flex: 0 0 150px; color: #8b929e; }
.minimal_card .info_row .value { max-width: calc(100% - 150px); color: #1f2937; font-weight: 500; }
.detail_content { padding: 24px; }
.status_card { padding: 28px 32px; border-radius: 20px; color: #fff; display: flex; align-items: center; justify-content: space-between; box-shadow: 0 8px 24px rgba(0,0,0,.1); }
.status_card.pending { background: linear-gradient(135deg, #ffb347, #ff8c42); }
.status_card.in_stock { background: linear-gradient(135deg, #46c98b, #16a765); }
.status_card.out_stock { background: linear-gradient(135deg, #8c9aab, #64748b); }
.status_label { font-size: 24px; opacity: .85; }
.status_value { margin-top: 8px; font-size: 40px; font-weight: 700; }
.status_warehouse { margin-top: 10px; font-size: 24px; opacity: .9; }
.product_card, .info_section { margin-top: 20px; background: #fff; border-radius: 20px; overflow: hidden; box-shadow: 0 3px 14px rgba(0,0,0,.05); }
.product_imgs { height: 340px; background: #f1f3f5; }
.product_imgs .van-swipe, .product_imgs .van-swipe-item { height: 100%; }
.product_imgs img { width: 100%; height: 100%; object-fit: contain; display: block; }
.product_main { padding: 28px; }
.product_name { font-size: 36px; font-weight: 700; color: #222; }
.product_code { margin-top: 12px; font-size: 26px; color: #777; }
.product_intro { margin-top: 18px; font-size: 26px; line-height: 1.6; color: #555; }
.section_title { padding: 24px 28px; font-size: 30px; font-weight: 600; color: #222; border-bottom: 1px solid #eee; }
.info_row, .report_row { min-height: 82px; padding: 18px 28px; box-sizing: border-box; display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #f2f2f2; font-size: 26px; }
.info_row:last-child, .report_row:last-child { border-bottom: 0; }
.info_row .label { flex: 0 0 150px; color: #888; }
.info_row .value { color: #333; text-align: right; word-break: break-all; }
.sn_value { font-family: monospace; font-weight: 600; }
.empty_text { color: #aaa; }
.stock_grid { padding: 28px 12px; display: grid; grid-template-columns: repeat(3, 1fr); }
.stock_item { display: flex; flex-direction: column; align-items: center; gap: 8px; color: #888; font-size: 23px; border-right: 1px solid #eee; }
.stock_item:last-child { border-right: 0; }
.stock_num { color: #2563eb; font-size: 36px; font-weight: 700; }
.action_footer { position: fixed; z-index: 20; left: 0; right: 0; bottom: 0; box-sizing: border-box; padding: 18px 30px calc(18px + env(safe-area-inset-bottom)); background: #fff; box-shadow: 0 -4px 18px rgba(0,0,0,.08); }
.popup_layout { height: 100%; display: flex; flex-direction: column; background: #f7f8fa; }
.popup_header { flex: 0 0 88px; padding: 0 30px; background: #fff; display: flex; align-items: center; justify-content: space-between; font-size: 32px; font-weight: 600; border-bottom: 1px solid #eee; }
.popup_body { flex: 1; min-height: 0; padding: 24px; overflow-y: auto; }
.popup_footer { flex: 0 0 auto; padding: 18px 28px calc(18px + env(safe-area-inset-bottom)); background: #fff; box-shadow: 0 -3px 12px rgba(0,0,0,.06); }
.out_summary { padding: 24px; background: #fff; border-radius: 16px; display: grid; gap: 18px; font-size: 27px; }
.out_summary > div { display: flex; justify-content: space-between; }
.summary_label { color: #888; }
.selected_header { margin: 28px 0 16px; display: flex; align-items: center; justify-content: space-between; font-size: 28px; font-weight: 600; }
.selected_list { min-height: 70px; padding: 18px; margin-bottom: 20px; border-radius: 14px; background: #fff; display: flex; flex-wrap: wrap; gap: 12px; }
.selected_tag { padding: 8px 12px; }
.selected_tag .van-icon { margin-left: 8px; }
.device_search { background: #fff; }
.device_list_wrap { flex: 1; min-height: 0; overflow-y: auto; padding: 0 22px; }
.device_item { margin-top: 16px; padding: 22px; background: #fff; border-radius: 14px; display: flex; align-items: center; justify-content: space-between; }
.device_item.disabled { opacity: .55; }
.device_item_info { min-width: 0; padding-right: 20px; }
.device_sn { font-size: 28px; font-weight: 600; color: #222; word-break: break-all; }
.device_meta { margin-top: 10px; font-size: 23px; color: #888; }
.current_label { margin-left: 12px; color: #1989fa; }
.report_missing { margin-top: 8px; color: #ee0a24; font-size: 22px; }
</style>
